<template>
    <WidgetVue
    
    title="Filter Keywords"
    desc="These words are ordered by the frequency. Most common words reflect the most common themes"
    >
      <div id="filterKeywords">
      <div class="search-box">
        <label for="keywordSearch">Search Keywords or Category:</label>
        <input
          type="text"
          id="keywordSearch"
          v-model="searchTerm"
          @input="filterKeywords"
          list="categoryList"
        />
        <datalist id="categoryList">
          <!-- Populate the datalist with unique categories -->
          <option v-for="category in uniqueCategories" :value="category" :key="category"></option>
        </datalist>
      </div>
      <div class="table_holder">
        <table>
          <thead>
            <tr>
              <th>Word </th>
              <th @click="sortBy('freq')">Frequency {{ sortIcon('freq') }}</th>
              <th @click="sortBy('positive_perc')">Positive Percentage {{ sortIcon('positive_perc') }}</th>
              <th @click="sortBy('negative_perc')">Negative Percentage {{ sortIcon('negative_perc') }}</th>
              <th @click="sortBy('category')">Category {{ sortIcon('category') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sortedKeywords" :key="item.word">
              <td><a href="#ReviewPanel" >{{ item.word }}</a></td>
              <td>{{ item.freq }}</td>
              <td>{{ item.positive_perc }}</td>
              <td>{{ item.negative_perc }}</td>
              <td>{{ item.category }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </WidgetVue>
  </template>
  
  <script>
  import WidgetVue from "@/components/WidgetVue.vue"
  export default {
    components: {
  WidgetVue
  },
    props: {
      title:{
          type: String,
          required: false
        },
        datum:{
          type: Object,
          required: true
        }
    },
    data() {
      return {
        sortedKeywords: [],
        sortOrder: 1,
        sortColumn: null,
        searchTerm: ''
        
      };
    },
    computed: {
      uniqueCategories() {
        // Extract unique categories from datum.wf
        const categories = this.datum.wf.map((item) => item.category);
        return [...new Set(categories)];
      },
    },
    watch: {
      'datum.wf': {
        handler: 'sortKeywords',
        deep: true,
        immediate: true,
      },
    },
    methods: {
      
      sortKeywords(column) {
        this.sortColumn = column;
        this.sortedKeywords = this.datum.wf.slice().sort((a, b) => {
          const modifier = this.sortOrder === 1 ? 1 : -1;
          return modifier * (a[column] - b[column]);
        });
      },
      sortBy(column) {
        if (this.sortColumn === column) {
          this.sortOrder *= -1;
        } else {
          this.sortColumn = column;
          this.sortOrder = 1;
        }
        this.sortKeywords(column);
      },
      sortIcon(column) {
        if (this.sortColumn === column) {
          return this.sortOrder === 1 ? '▼' : '▲';
        }
        return '⤵️';
      },
      filterKeywords() {
        const searchLower = this.searchTerm.toLowerCase();
        this.sortedKeywords = this.datum.wf.slice().filter((item) => {
          const wordMatches = item.word && item.word.toLowerCase().includes(searchLower);
          const categoryMatches = item.category && item.category.toLowerCase().includes(searchLower);
          return wordMatches || categoryMatches;
        });
      },
    },
  };
  </script>
  
  <style>
  .table_holder {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  
  #filterKeywords th,
  #filterKeywords td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  
  #filterKeywords th {
    background-color: #f2f2f2;
    cursor: pointer;
  }
  
  .search-box {
    margin-bottom: 10px;
  }
  
  .search-box label {
    margin-right: 10px;
  }
  </style>
  